import { Component, OnInit } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { LoadingController, ToastController } from '@ionic/angular';
import { BackendService } from '../core/services/backend-prod.service';
import { CustomPasswordValidators } from './custom-password-validators';
import jwt_decode from "jwt-decode";
import { AppRouterService } from '../core/services/app-router.service';
import { HelperService } from '../core/services/helper.service';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.page.html',
  styleUrls: ['./reset-password.page.scss'],
})
export class ResetPasswordPage implements OnInit {

  setPasswordform: UntypedFormGroup;
  token: any;
  regId:any;
  regemail: any;
  hide = true;
  confirmpwd = true;
  isPwdExp:boolean;
  constructor(
    private fb: UntypedFormBuilder,
    private backendService: BackendService,
    private route: ActivatedRoute,
    public toastController: ToastController,
    private appRouter: AppRouterService,
    public router: Router,
    public storage: Storage,
    public helperService: HelperService,
    public loadingController: LoadingController
  ) { }

  async ngOnInit() {
    this.setPasswordform = this.fb.group({
      'oldPassword': [''],
      'newPassword': [
        '',
        Validators.compose([
          // check whether the entered password has a number
          CustomPasswordValidators.patternValidator(/\d/, {
            hasNumber: true
          }),
          // check whether the entered password has a upper case letter
          CustomPasswordValidators.patternValidator(/[A-Z]/, {
            hasUpperCase: true 
          }),
          // check whether the entered password has a lower case letter
          CustomPasswordValidators.patternValidator(/[a-z]/, {
            hasSmallCase: true
          }),
          // check whether the entered password has a special character
          CustomPasswordValidators.patternValidator(
            /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
            {
              hasSpecialCharacters: true
            }
          ),
          Validators.minLength(8)
        ])
      ],
      'confirmPassword': [''],
    },
    {
      // check whether our password and confirm password match
      validator: CustomPasswordValidators.passwordMatchValidator
    });
     
    this.route.queryParams
    .subscribe(params => {
      this.token = params.token;
    });
    this.getStorage().then(async (res) => {
      this.isPwdExp = res.isPwdExpired;
      if(!this.isPwdExp){
        const decodeToken: any = await this.getDecodeToken(this.token);
        if(decodeToken) {
          //console.log(decodeToken);
          this.regemail = decodeToken.email;
          this.regId=decodeToken.id;
        }
      }else{
        this.regemail = res.email;
        this.regId = res.userId;
      }      
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
       this.helperService.dismissToast();
      }
    });
  }
  async getStorage() {
    let data = {
      userId: await this.storage.get("id"),
      email: await this.storage.get("email"),
      isPwdExpired: await this.storage.get("isPwdExpired"),
      showDialog: await this.storage.get("showDialog")
    }
    return data;
  }
  get setPasswordControls() { return this.setPasswordform.controls; }

  onSetPasswordSubmit() {
    if (this.setPasswordform.invalid) {
      this.helperService.presentToast("Form incomplete", 2000);
     return;
   }
   if(this.isPwdExp == true){
    if(this.setPasswordform.value.newPassword.trim() == this.setPasswordform.value.oldPassword.trim()){
      this.helperService.presentToast("New password cannot be the same as your old password.", 2000);
      return;
     }
     }
  this.helperService.loader();  
    let payload = {
      id: this.regId,
      email : this.regemail,       
      password: this.setPasswordform.value.newPassword.trim()
    }
    this.backendService.PostAPICall('resetPassword', payload, this.token).subscribe(
      data => {
        this.helperService.closeLoader();
        this.helperService.presentToast("Password successfully changed", 2000);
        this.appRouter.gotoPath('login');
      },
      err=>{
        //console.log(err);
        this.helperService.closeLoader()
        if(err.error.isTrusted){
          this.helperService.presentToastWithButton("Try again"); 
        }else{
          this.helperService.presentToast(err.error.detail, 2000);
        }
      }
    );    
  }
  
  async getDecodeToken (token: any) {
    if(token) {
      var decoded;
      await this.helperService.decode(token).then((d)=>{decoded=d});
      return decoded;
    }
    return;
  }
}
